import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Validable } from '../common-behaviors/validate.mixin';
import { WithMessages } from '../common-behaviors/with-messages.mixin';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { AtomService } from '../atom.service';
import {
  DateFilter,
  NumberFilter,
  StringFilter,
} from 'src/app/filter/filter';

import { Product } from './product.resource';
import { LegalDocumentVersion } from './legal-document-version.resource';

const ProductMixinBase = WithMessages(Validable(AtomResource));
@Resource({
  type: 'legaldocumentversionarchives',
})
export class LegalDocumentVersionArchive extends AtomResource {
  @Attribute() content?: string;

  @Relationship() legaldocumentversion?: LegalDocumentVersion;
  @Relationship() product?: Product;
}
export class LegalDocumentVersionArchiveConfig implements ResourceConfig {
  uncreatable = true;
  defaultSort='-id';
  tables = {
    includes: ['legaldocumentversion.legaldocument', 'product'],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        translatable: false,
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'createdAt',
        displayedDatas: [{ path: ['meta.created_at'], class: 'main', type: 'date'}],
        header: 'Archived At',
        displayed: true,
        sort: 'created_at',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'products',
        displayedDatas: [
          {
          path: ['product.name'],
          class: 'mat-body-2',
          },
          {
            path: ['product.commercialName'],
            class: 'mat-body-2',
          }],
        header: 'Product Name',
        displayed: true,
        link: {
          resource: 'products',
          filter: 'product.id',
          target: 'products',
          icon: 'public',
        },
        sort: 'product.name',
      },
      {
        columnDef: 'legaldocumentversion',
        displayedDatas: [
          { path: ['legaldocumentversion.legaldocument.name'], class: 'mat-body-2'},
          { path: ['legaldocumentversion.legaldocument.documentType'], class: 'mat-body-1'}
        ],
        header: 'Document Version / Type',
        displayed: true,
        link: {
          resource: 'legaldocumentversions',
          filter: 'legaldocumentversion.id',
          target: 'legaldocumentversions',
          icon: 'policy',
        },
        sort: 'legaldocumentversion.legaldocument.name',
      },
    ],
  };
  detail = {
    header: {
      icon: 'archive',
      title: [],
      id: true,
    },
    elements: [
        {
          showEmpty: true,
          list: [
            {
              icon: 'timer',
              title: 'Archived At',
              APIKey: 'createdAt',
              value: {
                path: ['meta.created_at'],
                type: 'date'
              },
            },
            {
              icon: 'public',
              title: 'Product Name - Commercial Name',
              APIKey: 'product',
              value: { path: ['product.name','product.commercialName']},
              link: {
                resource: 'products',
                filter: 'product.id',
                target: 'products',
              }
            },
            {
              icon: 'local_police',
              title: 'Document Version - Type',
              APIKey: 'legaldocumentversion',
              value: {
                path: ['legaldocumentversion.legaldocument.name', 'legaldocumentversion.legaldocument.documentType'],
              },
              link: {
                resource: 'legaldocumentversions',
                filter: 'legaldocumentversion.id',
                target: 'legaldocumentversions',
              }
            },
            {
              type: 'textarea',
              icon: 'description',
              title: 'Content',
              APIKey: 'content',
              value: {
                path: ['content'],
              },
            }
          ]
        }]
  };
  resource = LegalDocumentVersionArchive;
  resourceName = 'legaldocumentversionarchives';
  resourceKey = 'legaldocumentversionarchives';
  resourceKeySingle = 'legaldocumentversionarchive';
  includes = [
    'legaldocumentversion',
    'legaldocumentversion.legaldocument',
    'product'
  ];
  filters = [
    new NumberFilter('id', 'ID'),
    new DateFilter('created_at', 'Created Date', true),
    new NumberFilter('product.id', 'Product Id'),
    new StringFilter('product.name', 'Product Name'),
  ];
  constructor(private atom: AtomService, public hosted: string = 'legaldocumentversion') {}
}
